import moment from "moment";
import {
  CodeAndDescription,
  CreditReportAccountOverview
} from "types/landlord/reports";

export const buildPaymentHistoryGrid = (
  payment_history: CreditReportAccountOverview["payment_history"],
  date_reported: string
): CodeAndDescription[] => {
  const monthReported = new Date(date_reported).getMonth();

  const filtered_payment_history =
    payment_history?.filter((el) => el.code !== "/") || [];

  if (!filtered_payment_history.length) return [];

  let ret = filtered_payment_history;

  if (!Number.isNaN(monthReported) && monthReported !== 11) {
    const prevMonthLength = 11 - monthReported >= 0 ? 11 - monthReported : 0;
    const prevMonth = Array(prevMonthLength).fill({
      code: "no_data",
      description: "No payment history"
    });
    const nextMonthLength = monthReported + 1 >= 0 ? monthReported + 1 : 0;
    const nextMonth = Array(nextMonthLength).fill({
      code: "no_data",
      description: "No payment history"
    });

    ret = [...prevMonth, ...filtered_payment_history, ...nextMonth];
  }

  const inversed: CodeAndDescription[] = [];

  for (let i = 0; i < ret.length; i = i + 12)
    inversed.push(...ret.slice(i, i + 12).reverse());

  return inversed;
};

export const paymentHistoryYears = (
  payment_history: CreditReportAccountOverview["payment_history"],
  date_reported?: string | null
): string[] => {
  const rowCount = Math.ceil(
    buildPaymentHistoryGrid(payment_history, date_reported || "").length / 12
  );

  if (!rowCount) return [];

  const anchor = date_reported ? moment(date_reported) : null;

  if (!anchor?.isValid()) return Array(rowCount).fill("");

  return Array.from({ length: rowCount }, (_, idx) =>
    anchor.clone().subtract(idx, "year").format("YYYY")
  );
};
